import { render } from "./ASide.vue?vue&type=template&id=bc2c48ee"
import script from "./ASide.vue?vue&type=script&lang=js"
export * from "./ASide.vue?vue&type=script&lang=js"

import exportComponent from "/app/app-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__